import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { FaArrowLeft } from 'react-icons/fa';

const Container = styled.div`
  padding: 1rem;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: var(--text-primary);
  font-size: 16px;
  cursor: pointer;
  padding: 0.5rem 0;
  margin-bottom: 1rem;

  svg {
    font-size: 20px;
  }
`;

const Title = styled.h1`
  font-size: 24px;
  color: var(--text-primary);
  margin: 0 0 1.5rem 0;
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  font-size: 20px;
  color: var(--text-primary);
  margin: 0 0 1rem 0;
`;

const Content = styled.div`
  color: var(--text-secondary);
  line-height: 1.6;
  font-size: 16px;

  p {
    margin: 0 0 1rem 0;
  }

  ul {
    margin: 0 0 1rem 0;
    padding-left: 1.5rem;
  }

  li {
    margin-bottom: 0.5rem;
  }
`;

const Legal: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <Container>
      <BackButton onClick={() => navigate('/profile')}>
        <FaArrowLeft />
        {t('common.back')}
      </BackButton>

      <Title>{t('legal.title')}</Title>

      <Section>
        <SectionTitle>{t('legal.terms.title')}</SectionTitle>
        <Content>
          <p>{t('legal.terms.lastUpdated')}</p>
          <p>{t('legal.terms.intro')}</p>
          <ul>
            <li>{t('legal.terms.terms1')}</li>
            <li>{t('legal.terms.terms2')}</li>
            <li>{t('legal.terms.terms3')}</li>
          </ul>
        </Content>
      </Section>

      <Section>
        <SectionTitle>{t('legal.privacy.title')}</SectionTitle>
        <Content>
          <p>{t('legal.privacy.intro')}</p>
          <ul>
            <li>{t('legal.privacy.points1')}</li>
            <li>{t('legal.privacy.points2')}</li>
            <li>{t('legal.privacy.points3')}</li>
          </ul>
        </Content>
      </Section>

      <Section>
        <SectionTitle>{t('legal.cookies.title')}</SectionTitle>
        <Content>
          <p>{t('legal.cookies.intro')}</p>
          <ul>
            <li>{t('legal.cookies.types1')}</li>
            <li>{t('legal.cookies.types2')}</li>
            <li>{t('legal.cookies.types3')}</li>
          </ul>
        </Content>
      </Section>

      <Section>
        <SectionTitle>{t('legal.contact.title')}</SectionTitle>
        <Content>
          <p>{t('legal.contact.email')}</p>
          <p>{t('legal.contact.address')}</p>
          <p>{t('legal.contact.phone')}</p>
        </Content>
      </Section>
    </Container>
  );
};

export default Legal; 